// extracted by mini-css-extract-plugin
export default {"productos":"Productos_productos__23e0a"};